// UnitStatusSummary/constants.ts
import { STRING } from "@constants";

export const UNIT_STATUS_ITEMS = [
  {
    label: STRING.UNIT_STATUS.RENTED,
    icon: "pi pi-user",
    color: "surface-100 text-blue-600",
    bg: "bg-blue-50",
    key: "rented",
  },
  {
    label: STRING.UNIT_STATUS.RESERVED,
    icon: "pi pi-bookmark",
    color: "surface-100 text-orange-600",
    bg: "bg-orange-50",
    key: "reserved",
  },
  {
    label: STRING.UNIT_STATUS.AVAILABLE,
    icon: "pi pi-box",
    color: "surface-100 text-green-700",
    bg: "bg-green-50",
    key: "available",
  },
  {
    label: STRING.UNIT_STATUS.READY,
    icon: "pi pi-send",
    color: "surface-100 text-cyan-700",
    bg: "bg-cyan-50",
    key: "ready",
  },
  {
    label: STRING.UNIT_STATUS.DIRTY,
    icon: "pi pi-ban",
    color: "surface-100 text-red-600",
    bg: "bg-red-50",
    key: "dirty",
  },
];
